import React from 'react';
import { withStyles } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { NEWS_IMAGE_BASE_URL } from '../../constants/ui';

import styles from './styles';

function SearchItem(props){
  const { classes, item, seoNews } = props;

  return (
    <>
      <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.image}>
            <img src={`${NEWS_IMAGE_BASE_URL}/small/${item.picture}`} alt={ item.name } />
          </div>
          <div className={classes.content}>
            <NavLink
              to={{
                pathname: `/tin-tuc/chi-tiet/${item.alias}`,
                state: { item, seoNews }
              }}
            >
              <h4>{item.name}</h4>
            </NavLink>
            <p dangerouslySetInnerHTML = {{ __html: item.description }}>
            </p>
          </div>
        </div>
      </div>
    </> 
  );
}

export default withStyles(styles)(SearchItem);